<template>
  <div>
    <v-card :loading="loading">
      <v-system-bar>Anlässe neu</v-system-bar>
      <v-data-table
        item-key="id"
        :headers="headers"
        hide-default-footer
        :items="itemsFiltered"
        disable-pagination
        :items-per-page="-1"
        :item-class="() => 'clickable'"
        @click:row="
          (item) =>
            $router.push({
              name: 'InvoiceEventEdit',
              params: { id: item.id },
            })
        "
      >
        <template v-slot:item.creator="{ item }">
          <v-chip-group column>
            <PersonItem color="primary" small :value="item.creator" />
            <PersonItem
              small
              v-for="member in item.members"
              :key="member.id"
              :value="member"
            />
          </v-chip-group>
        </template>

        <template v-slot:item.startDate="{ item }">
          {{ formatDatespan(item.startDate, item.endDate) }}
        </template>
        <template v-slot:footer
          ><TableFooter
            :items="itemsFiltered"
            label="Anlässe"
            labelSingular="Anlass"
        /></template>
      </v-data-table>
    </v-card>
    <v-btn
      @click="$router.push({ name: 'InvoiceEventCreate' })"
      color="primary"
      class="ma-4"
      >erstellen</v-btn
    >
    <router-view @updated="fetchData" />
  </div>
</template>

<script>
import { defineComponent } from "vue";

import PersonItem from "common/components/PersonItem.vue";
import TableFooter from "common/components/TableFooter.vue";
import { formatDatespan } from "common/utils/date.js";

const helpText = `
`;

export default defineComponent({
  components: {
    PersonItem,
    TableFooter,
  },
  props: ["search"],
  data() {
    return {
      helpText,
      loading: false,
      headers: [
        { text: "Teilnehmer:innen", value: "creator" },

        { text: "Beschreibung", value: "description" },
        { text: "Dauer", value: "startDate" },
      ],
      items: [],
    };
  },
  computed: {
    itemsFiltered() {
      return this.items.filter(
        (el) =>
          !this.search ||
          el.description.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    formatDatespan,
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "finance/invoiceevent",
      });
      this.loading = false;
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
